module.exports = __webpack_public_path__ + "static/media/bac.27f163e3.webp";